/**
 * We have non-React code (e.g. sagas) that need to trigger page navigations.
 * This module acts as a pass-through so non-React code can trigger page
 * navigations as long as someone else provides the implementation.
 */
import type { NavigateFunction, NavigateOptions, To } from "react-router-dom";

let _navigate: NavigateFunction | undefined;

export function setNavigateImpl(navigateFn: NavigateFunction) {
  _navigate = navigateFn;
}

export const navigate = (to: To, options?: NavigateOptions) => {
  if (!_navigate) throw new Error("navigate implementation was not provided");

  // when NavigateFunction has multiple signatures.
  return _navigate(to, options);
};
